export const roleWithCourses = ["Soft Skills Facilitator", "Technical Trainer"]